import { useTenant } from '@emerald-works-nova/auth'
import consts from '../consts'

export function useDisplayAddToPlaylist () {
  const tenant = useTenant()
  const displayPlaylist = tenant.features?.playlists || tenant.pk === consts.DEFAULT_CLUB_PK
  return displayPlaylist
}
